import {provideRouter, RouterConfig} from "@angular/router";
import {LoginComponent} from "./login/login.component";
import {HomeComponent} from "./home/home.component";
import {HomeTecnicoComponent} from "./homeTecnico/homeTecnico.component";
import {GraficosComponent} from "./graficos/graficos.component";
import {AlarmasComponent} from "./alarmas/alarmas.component";
import {EmpresaComponent} from "./empresa/empresa.component";
import {SucursalComponent} from "./sucursal/sucursal.component";
import {UbicacionComponent} from "./ubicacion/ubicacion.component";
import {GatewayComponent} from "./gateway/gateway.component";
import {NodoComponent} from "./nodo/nodo.component";
import {SensorComponent} from "./sensor/sensor.component";
import {TipoSensorComponent} from "./tipoSensor/tipoSensor.component";
import {ABMGeneralComponent} from "./abmgeneral/abmgeneral.component";
import {UsuariosComponent} from "./usuarios/usuario.component";
import {TipoVariableComponent} from "./tipoVariable/tipoVariable.component";
import {TipoBateriaComponent} from "./tipoBateria/tipoBateria.component";
import {HistoricoComponent} from "./historico/historico.component";
import {ActividadesComponent} from "./actividades/actividades.component";
import {AuthGuard} from "./auth/auth-guard.service";
import {LoginService} from "./login/login.service";
import {ResetComponent} from "./reset/reset.component";
import {MiCuentaComponent} from "./miCuenta/miCuenta.component";
import {CambiarPasswordComponent} from "./cambiarPassword/cambiarPassword.component";
import {LandingPageComponent} from "./landingPage/landingPage.component";
import {RecargaCreditoComponent} from "./recargaCredito/recargaCredito.component";
import {CalibracionComponent} from "./calibracion/calibracion.component";
import {DocumentoComponent} from "./documento/documento.component";
import {RegAlarmasComponent} from "./regAlarma/regalarmas.component";
import {AuthorizationGuard} from "./auth/authorization-guard.service";
import {MenuService} from "./menu/menu.service";
import { PlanComponent } from "./plan/plan.component";

export const routes: RouterConfig = [
    {path: "", component: LoginComponent},
    {path: "login", component: LoginComponent},
    {path: "home", component: HomeComponent, canActivate: [AuthGuard]},
    {
        path: "homeTecnico",
        component: HomeTecnicoComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "graficos",
        component: GraficosComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "alarmas",
        component: AlarmasComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "empresa",
        component: EmpresaComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "sucursal",
        component: SucursalComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "ubicacion",
        component: UbicacionComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "gateway",
        component: GatewayComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "nodo",
        component: NodoComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "sensor",
        component: SensorComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "configuracion",
        component: ABMGeneralComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "usuarios",
        component: UsuariosComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "tipoVariable",
        component: TipoVariableComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "tipoSensor",
        component: TipoSensorComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "tipoBateria",
        component: TipoBateriaComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "actividades",
        component: ActividadesComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "historico",
        component: HistoricoComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {path: "miCuenta", component: MiCuentaComponent, canActivate: [AuthGuard]},
    {path: "cambiarPassword", component: CambiarPasswordComponent},
    {path: "reset/:token", component: ResetComponent},
    {
        path: "recargaCredito",
        component: RecargaCreditoComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "presupuestoCalibracion/:id",
        component: CalibracionComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "documentos",
        component: DocumentoComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "regAlarmas",
        component: RegAlarmasComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {
        path: "planes",
        component: PlanComponent,
        canActivate: [AuthGuard, AuthorizationGuard],
    },
    {path: "404", component: LoginComponent},
    {path: "**/:*", redirectTo: "/404"},
    {path: "**", redirectTo: "/404"},

    {
        path: "",
        redirectTo: "/login",
        pathMatch: "full",
    },
];

export const APP_ROUTER_PROVIDERS = [
    provideRouter(routes),
    AuthGuard,
    AuthorizationGuard,
    LoginService,
    MenuService,
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/app.routes.ts